import { useEffect, useState } from 'react';
import type { ScheduleState } from '../lib/schedule';
import { fmtTime, fmtCountdown, fmtDuration } from '../lib/format';
import { ago } from '../lib/statusUi';

/** O4 — minimum interval not yet elapsed. Submission is not possible. */
export default function Blocked(props: {
  schedule: ScheduleState;
  equipmentName: string;
  onBack: () => void;
}) {
  const { schedule, equipmentName, onBack } = props;
  const target = schedule.nextAvailableAt ? Date.parse(schedule.nextAvailableAt) : 0;
  const gapMin = schedule.lastReadingAt && schedule.nextAvailableAt
    ? Math.round((Date.parse(schedule.nextAvailableAt) - Date.parse(schedule.lastReadingAt)) / 60000)
    : null;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const remaining = target - now;
  useEffect(() => {
    if (target && remaining <= 0) onBack();
  }, [target, remaining, onBack]);

  return (
    <div className="app">
      <div className="hero">
        <div className="hero-band muted" />
        <div className="hero-body center">
          <h1>{equipmentName}</h1>
          <div className="hero-loc">Reading not available yet</div>
          <div className="big" style={{ margin: '10px 0 4px' }}>{fmtCountdown(remaining)}</div>
          <div className="muted tiny">until the next reading is allowed</div>
        </div>
      </div>

      <div className="card">
        <div className="row"><span className="k">Last reading</span><span className="v">{fmtTime(schedule.lastReadingAt)} ({ago(schedule.lastReadingAt)})</span></div>
        <div className="row"><span className="k">Minimum gap</span><span className="v">{gapMin !== null ? fmtDuration(gapMin) : '—'}</span></div>
        <div className="row"><span className="k">Available at</span><span className="v">{fmtTime(schedule.nextAvailableAt)}</span></div>
      </div>

      <p className="center muted">Come back after the minimum interval. This screen updates on its own.</p>
      <button className="secondary" onClick={onBack}>Back</button>
    </div>
  );
}
